import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import Toasted from 'vue-toasted';
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false;

Vue.use(Toasted, {
    action: {
        text: 'X',
        onClick: (e, toastObject) => {
            toastObject.goAway(0);
        }
    },
    position: 'top-center',
    duration: 3000,
    keepOnHover: true,
});

Vue.use(VueGtag, {
    config: { id: "G-8WHE36YHX4" }
});

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');